import { api } from "./api";

const BASE = "/admin/promociones";

export async function fetchPromoResumen() {
  const { data } = await api.get(`${BASE}/resumen`);
  return data;
}

export async function fetchPromoHistorial(params = {}) {
  const { data } = await api.get(`${BASE}/historial`, { params });
  return data; // { items, total, page, page_size }
}

export async function fetchPromoUsuario(userId) {
  const { data } = await api.get(`${BASE}/usuario/${userId}`);
  return data; // { usuario, items }
}

export async function fetchPromoAuditoria(limite = 50) {
  const { data } = await api.get(`${BASE}/auditoria`, { params: { limite } });
  return data;
}

// Devuelve { conflict: activeBenefit } cuando ya existe un beneficio activo (HTTP 409).
export async function otorgarCortesia(payload) {
  try {
    const { data } = await api.post(`${BASE}/cortesia`, payload);
    return data;
  } catch (e) {
    if (e?.response?.status === 409) return { conflict: e.response.data.active };
    throw e;
  }
}

export async function convertirEmbajador(payload) {
  try {
    const { data } = await api.post(`${BASE}/embajador`, payload);
    return data;
  } catch (e) {
    if (e?.response?.status === 409) return { conflict: e.response.data.active };
    throw e;
  }
}

export async function renovarBeneficio(benefitId, duracionDias) {
  const { data } = await api.post(`${BASE}/${benefitId}/renovar`, { duracion_dias: duracionDias || null });
  return data;
}

export async function finalizarBeneficio(benefitId) {
  const { data } = await api.post(`${BASE}/${benefitId}/finalizar`);
  return data;
}
